import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';

@Injectable()
export class LanguageService {

  private languages: Language[];

  constructor(private apiSvc: ApiService) { }

  public loadLanguages(): Promise<Language[]> {

    const p = new Promise<Language[]>((resolve, reject) => {

      //If the language collection is already populated, then return it, otherwise load from the API
      //Eventually replacing this with a cache would be better

      if (this.languages && this.languages.length > 0) {
        resolve(this.languages);
        return;
      }

      this.apiSvc.get("api/Languages", null).subscribe(
        (data: Language[]) => {
          console.log("LanguageService.loadLanguages", data);
          this.languages = data;
          resolve(this.languages);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }
}

export class Language {
  Id: string;
  Code: string;
  Name: string;
  Description: string;
  IsTested: boolean
}
